import React, { useState } from "react";
import { AppBar, Toolbar, Button, Box, IconButton, Drawer, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import logo from "../Images/great_lakes3.png";

const Navbar = () => {
    const navigate = useNavigate();
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const menuItems = [
        { text: "Home", path: "/" },
        { text: "Lessons", path: "/lessons" },
        { text: "Programs", path: "/programs" },
        { text: "About", path: "/about" },
        { text: "Contact", path: "/contact" },
    ];

    return (
        <AppBar position="fixed" color="primary" sx={{ zIndex: 1100 }}>
            <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                {/* Hamburger Menu (Only Shows on Mobile) */}
                <Box sx={{ display: { xs: "block", md: "none" }, position: "absolute", left: 16 }}>
                    <IconButton edge="start" color="inherit" onClick={handleDrawerToggle}>
                        <MenuIcon />
                    </IconButton>
                </Box>

                {/* Logo (Centered on Mobile, Right on Desktop) */}
                <Box
                    sx={{
                        display: { xs: "flex", md: "none" }, // Show this for mobile only
                        justifyContent: "center", // Center on mobile
                        position: "absolute",
                        left: 0,
                        right: 0,
                        margin: "auto", // Center the logo horizontally
                        top: "50%",
                        transform: "translateY(-50%)", // Center the logo vertically
                        width: "50px", // Optional, restrict logo width
                        height: "auto",
                    }}
                >
                    <img
                        src={logo}
                        alt="Logo"
                        style={{
                            width: "50px",
                            height: "auto",
                        }}
                    />
                </Box>

                {/* Desktop Logo (Right Aligned on Desktop) */}
                <Box
                    sx={{
                        display: { xs: "none", md: "flex" }, // Hide on mobile
                        position: "absolute",
                        justifyContent: "flex-end", // Align logo to the right on desktop
                        flexGrow: 0,
                    }}
                >
                    <img
                        src={logo}
                        alt="Logo"
                        style={{
                            width: "50px",
                            height: "auto",
                        }}
                    />
                </Box>

                {/* Desktop Buttons (Centered) */}
                <Box sx={{ display: { xs: "none", md: "flex" }, gap: 3, justifyContent: "center", flexGrow: 1 }}>
                    {menuItems.map((item) => (
                        <Button
                            key={item.text}
                            variant="contained"
                            color="primary"
                            onClick={() => navigate(item.path)}
                            sx={{ px: 3 }}
                        >
                            {item.text}
                        </Button>
                    ))}
                </Box>
            </Toolbar>

            {/* Mobile Drawer */}
            <Drawer anchor="left" open={mobileOpen} onClose={handleDrawerToggle}>
                <List>
                    {menuItems.map((item) => (
                        <ListItem key={item.text} disablePadding>
                            <ListItemButton onClick={() => { navigate(item.path); setMobileOpen(false); }}>
                                <ListItemText primary={item.text} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Drawer>
        </AppBar>
    );
};

export default Navbar;
